'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RacesNoble = undefined;
exports.getUpcomingRaces = getUpcomingRaces;
exports.getRaceDistancesByEventId = getRaceDistancesByEventId;
exports.getRaceTypesByEventId = getRaceTypesByEventId;
exports.getRaceTimesByEventId = getRaceTimesByEventId;
exports.getAthlinksRaces = getAthlinksRaces;
exports.getAthlinksRacesByMasterId = getAthlinksRacesByMasterId;
exports.getRaceByEventCourseId = getRaceByEventCourseId;
exports.getDivisionsByEventCourseId = getDivisionsByEventCourseId;
exports.getDivisionsByEventId = getDivisionsByEventId;

var _rx = require('rx');

var _eventBusRx = require('event-bus-rx');

var _eventBusRx2 = _interopRequireDefault(_eventBusRx);

var _bastetjs = require('bastetjs');

var _distanceConverter = require('../distanceConverter');

var _distanceConverter2 = _interopRequireDefault(_distanceConverter);

var _ErosApi = require('../apis/ErosApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUpcomingRaces() {
  var streamId = 'GetUpcomingRaces';
  require('datejs');

  var body = {
    '_source': ['id', 'event_id', 'athlinks_id', 'name', 'tag', 'type', 'sub_type', 'pref_distance_unit', 'course_distance', 'planned_start_time', 'planned_end_time'],
    'query': {
      'range': {
        'planned_start_time': {
          'gte': '' + Date.today().getTime() / 1000
        }
      }
    },
    'size': 100,
    'sort': [{ 'planned_start_time': {
        'order': 'asc',
        'missing': '_last',
        'ignore_unmapped': true
      }
    }]
  };

  return _ErosApi.ErosApi.query(streamId, 'race/ctlive/_search', body).map(function (msg) {

    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (hit) {
        var distance = _distanceConverter2.default.getDistanceFromCTLiveRace(hit.pref_distance_unit, hit.course_distance);

        return {
          id: hit.id,
          name: hit.name,
          tag: hit.tag,
          type: hit.type,
          subType: hit.subType,
          eventId: hit.event_id,
          athlinksId: hit.athlinks_id,
          meters: hit.course_distance,
          distance: distance.displayValue,
          plannedEndTime: hit.planned_end_time,
          plannedStartTime: hit.planned_start_time
        };
      })
    });
  });
}

function getRaceDistancesByEventId(_ref) {
  var eventId = _ref.eventId;
  var athlinksId = _ref.athlinksId;

  var id = eventId || athlinksId;
  var streamId = 'GetRaceDistances' + (eventId ? '-' : 'WithAthlinksId-') + id;

  var body = {
    '_source': ['id', 'event_id', 'athlinks_id', 'name', 'tag', 'pref_distance_unit', 'course_distance'],
    query: {
      term: eventId ? { 'event_id': id } : { 'athlinks_id': id }
    },
    'sort': [{ 'course_distance': {
        'order': 'asc'
      }
    }]
  };

  return _ErosApi.ErosApi.query(streamId, 'race/ctlive/_search', body).map(function (msg) {

    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (hit) {
        var distance = _distanceConverter2.default.getDistanceFromCTLiveRace(hit.pref_distance_unit, hit.course_distance);

        return {
          id: hit.id,
          eventId: hit.event_id,
          athlinksId: hit.athlinks_id,
          distance: distance.displayValue
        };
      })
    });
  });
}

function getRaceTypesByEventId(_ref2) {
  var eventId = _ref2.eventId;
  var athlinksId = _ref2.athlinksId;

  var id = eventId || athlinksId;
  var streamId = 'GetRaceTypes' + (eventId ? '-' : 'WithAthlinksId-') + id;

  var body = {
    '_source': ['id', 'event_id', 'athlinks_id', 'name', 'type', 'sub_type'],
    query: {
      term: eventId ? { 'event_id': id } : { 'athlinks_id': id }
    }
  };

  return _ErosApi.ErosApi.query(streamId, 'race/ctlive/_search', body).map(function (msg) {

    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (hit) {
        return {
          id: hit.id,
          eventId: hit.event_id,
          athlinksId: hit.athlinks_id,
          type: hit.type,
          subType: hit.sub_type
        };
      })
    });
  });
}

function getRaceTimesByEventId(_ref3) {
  var eventId = _ref3.eventId;
  var athlinksId = _ref3.athlinksId;

  var id = eventId || athlinksId;
  var streamId = 'GetRaceTimes' + (eventId ? '-' : 'WithAthlinksId-') + id;

  var body = {
    '_source': ['id', 'event_id', 'athlinks_id', 'name', 'type', 'sub_type', 'planned_start_time', 'planned_end_time'],
    size: 50,
    query: {
      term: eventId ? { event_id: eventId } : { 'athlinks_id': athlinksId }
    },
    'sort': [{ 'planned_start_time': { 'order': 'asc' } }]
  };

  return _ErosApi.ErosApi.query(streamId, 'race/ctlive/_search', body).map(function (msg) {

    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (hit) {
        return {
          id: hit.id,
          eventId: hit.event_id,
          athlinksId: hit.athlinks_id,
          name: hit.name,
          type: hit.type,
          subType: hit.sub_type,
          plannedStartTime: hit.planned_start_time,
          plannedEndTime: hit.planned_end_time
        };
      })
    });
  });
}

function _getAthlinksRaceFields() {
  return ['CourseID', 'Meters', 'EventID', 'MasterID', 'EventCourseID', 'StartEpoch', 'EventName', 'RaceName'];
}

function _athlinksRaceQuery(query, size) {
  return {
    _source: _getAthlinksRaceFields(),
    size: size || 10,
    query: query
  };
}

function _mapHitFields(hit) {
  return {
    courseId: hit.CourseID,
    meters: hit.Meters,
    eventId: hit.EventID,
    masterId: hit.MasterID,
    eventCourseId: hit.EventCourseID,
    startEpoch: hit.StartEpoch,
    eventName: hit.EventName,
    raceName: hit.RaceName
  };
}

function getAthlinksRaces(_ref4) {
  var athlinksId = _ref4.athlinksId;

  var streamId = 'GetAthlinksRaces';

  var query = _athlinksRaceQuery({ term: { EventID: athlinksId } }, 50);

  return _ErosApi.ErosApi.query(streamId, 'race/athlinks/_search', query).map(function (msg) {
    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (hit) {
        return _mapHitFields(hit);
      }).sort(function (a, b) {
        return a.raceName > b.raceName;
      })
    });
  });
}

function getAthlinksRacesByMasterId(_ref5) {
  var masterId = _ref5.masterId;

  var streamId = 'getAthlinksRacesByMasterId';

  var query = Object.assign({}, _athlinksRaceQuery({ term: { MasterID: masterId } }, 500), { sort: [{ StartEpoch: { order: 'desc' } }] });

  return _ErosApi.ErosApi.query(streamId, 'race/athlinks/_search', query).map(function (msg) {
    if ('isLoading' in msg && msg.isLoading) {
      return [];
    }

    var now = Date.now() / 1000;
    return _bastetjs.utils.entityDecoder.decode({
      races: msg.hits.map(function (_) {
        return _mapHitFields(_);
      }).filter(function (_) {
        return _.startEpoch < now;
      })
    });
  });
}

function getRaceByEventCourseId(_ref6) {
  var eventCourseId = _ref6.eventCourseId;

  var streamId = 'getAthlinksRaceByEventCourseId';

  var query = Object.assign({}, _athlinksRaceQuery({ match: { EventCourseID: eventCourseId } }));

  return _ErosApi.ErosApi.query(streamId, 'race/athlinks/_search', query).map(function (msg) {
    return 'isLoading' in msg && msg.isLoading ? [] : msg.hits.map(function (hit) {
      return _bastetjs.utils.entityDecoder.decode(_mapHitFields(hit));
    });
  });
}

function _assembleDivisionRecords(msg, hits) {
  return 'isLoading' in msg && msg.isLoading ? [] : hits.map(function (hit) {
    return _bastetjs.utils.entityDecoder.decode(hit);
  });
}

function getDivisionsByEventCourseId(_ref7) {
  var eventCourseId = _ref7.eventCourseId;

  var streamId = 'GetDivisionsByEventCourseId';
  var query = {
    _source: ['divisionId', 'courseId', 'eventId', 'eventCourseId', 'division'],
    query: { match: { eventCourseId: eventCourseId } },
    size: 50
  };

  return _ErosApi.ErosApi.query(streamId, 'race_division/athlinks/_search', query).map(function (msg) {
    return _assembleDivisionRecords(msg, msg.hits || []);
  });
}

function getDivisionsByEventId(_ref8) {
  var eventId = _ref8.eventId;

  var streamId = 'GetDivisionsByEventId';
  var query = {
    _source: ['divisionId', 'courseId', 'eventId', 'eventCourseId', 'division'],
    query: { match: { eventId: eventId } },
    size: 500
  };

  return _ErosApi.ErosApi.query(streamId, 'race_division/athlinks/_search', query).map(function (msg) {
    return _assembleDivisionRecords(msg, msg.hits || []);
  });
}

// For testing
var RacesNoble = exports.RacesNoble = {
  getDivisionsByEventId: getDivisionsByEventId,
  getDivisionsByEventCourseId: getDivisionsByEventCourseId,
  getRaceDistancesByEventId: getRaceDistancesByEventId,
  getRaceTypesByEventId: getRaceTypesByEventId,
  getRaceTimesByEventId: getRaceTimesByEventId,
  getUpcomingRaces: getUpcomingRaces,
  getAthlinksRaces: getAthlinksRaces,
  getAthlinksRacesByMasterId: getAthlinksRacesByMasterId,
  getRaceByEventCourseId: getRaceByEventCourseId
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/RacesNoble.js
// module id = 425
// module chunks = 0